import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { rethrowCloseCauseIfNeeded2q8fs9csuucwc as rethrowCloseCauseIfNeeded } from './ByteReadChannelOperations.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { get_size2imoy2jq11jxl as get_size } from './core/BytePacketBuilder.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_autoFlush() {
  return false;
}
var ByteWriteChannelClass;
function ByteWriteChannel() {
  if (ByteWriteChannelClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ByteWriteChannel', VOID, VOID, VOID, [0]);
    ByteWriteChannelClass = $;
  }
  return ByteWriteChannelClass;
}
function *_generator_flushIfNeeded__xji6le(_this__u8e3s4, $completion) {
  rethrowCloseCauseIfNeeded(_this__u8e3s4);
  if (_this__u8e3s4.i4j() || get_size(_this__u8e3s4.m4j()) >= 1048576) {
    var tmp = _this__u8e3s4.x4i($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  return Unit_instance;
}
function flushIfNeeded(_this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_flushIfNeeded__xji6le.bind(VOID, _this__u8e3s4), $completion);
}
//region block: exports
export {
  flushIfNeeded as flushIfNeededyux8o68tvpw5,
  ByteWriteChannel as ByteWriteChannel3jkhlhzuuoxp1,
};
//endregion

//# sourceMappingURL=ByteWriteChannel.mjs.map
